<svg
  width="102"
  height="14"
  viewBox="0 0 102 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
<title>Treatwell Rewards</title>
<path
    d="M4.72764 8.84647C4.72764 10.2945 5.53747 11.1672 6.87371 11.1672C7.29886 11.1672 7.72407 11.0879 8.18973 10.9292V11.068C7.42035 12.2383 6.32708 12.8929 4.95032 12.8929C3.14842 12.8929 1.83247 11.7821 1.83247 9.67957V4.12574H0.0913086V3.90751L4.48466 0H4.72764V8.84647Z"
    fill="var(--color-bloom-base-navy-800)"
  />
<path
    d="M12.7549 12.8334L14.2328 9.63989L11.1757 2.79674H5.43623V4.12569H8.60445L12.5524 12.8334H12.7549Z"
    fill="var(--color-bloom-base-navy-800)"
  />
<path
    d="M13.6862 2.79676H16.8446L19.9017 9.6399L18.4237 12.8334H18.2213L13.6862 2.79676Z"
    fill="var(--color-bloom-base-navy-800)"
  />
<path
    d="M20.9343 6.62494C20.9343 5.67288 20.4889 3.76869 19.9827 2.79676H23.0601L21.076 6.62494H20.9343Z"
    fill="var(--color-bloom-base-navy-800)"
  />
<path
    d="M32.7353 12.9507H30.6773L28.1713 8.65268H26.9253V12.9507H25.0913V2.59068H29.2913C30.3926 2.59068 31.2326 2.90334 31.8113 3.52868C32.306 4.06068 32.5533 4.76068 32.5533 5.62868C32.5533 6.46868 32.32 7.15001 31.8533 7.67268C31.4426 8.13934 30.878 8.43334 30.1593 8.55468L32.7353 12.9507ZM26.9253 6.88868H29.3193C29.7766 6.88868 30.1313 6.76268 30.3833 6.51068C30.6073 6.29601 30.7193 6.00668 30.7193 5.64268C30.7193 5.21334 30.5746 4.88201 30.2853 4.64868C30.0426 4.45268 29.7206 4.35468 29.3193 4.35468H26.9253V6.88868Z"
    fill="var(--color-bloom-teal-700)"
  />
<path
    d="M42.4564 12.9507H35.8904V2.59068H42.4564V4.35468H37.7244V6.66468H41.4484V8.42868H37.7244V11.1867H42.4564V12.9507Z"
    fill="var(--color-bloom-teal-700)"
  />
<path
    d="M56.056 12.9507H54.208L52.192 5.95068L50.176 12.9507H48.328L45.108 2.59068H47.096L49.238 10.1367L51.394 2.59068H52.99L55.132 10.1367L57.288 2.59068H59.276L56.056 12.9507Z"
    fill="var(--color-bloom-teal-700)"
  />
<path
    d="M70.5379 12.9507H68.5499L67.6959 10.7387H63.2299L62.3899 12.9507H60.4019L64.5459 2.59068H66.4079L70.5379 12.9507ZM67.0379 8.98868L65.4699 4.87268L63.8879 8.98868H67.0379Z"
    fill="var(--color-bloom-teal-700)"
  />
<path
    d="M80.9768 12.9507H78.9188L76.4128 8.65268H75.1668V12.9507H73.3328V2.59068H77.5328C78.6341 2.59068 79.4741 2.90334 80.0528 3.52868C80.5474 4.06068 80.7948 4.76068 80.7948 5.62868C80.7948 6.46868 80.5614 7.15001 80.0948 7.67268C79.6841 8.13934 79.1194 8.43334 78.4008 8.55468L80.9768 12.9507ZM75.1668 6.88868H77.5608C78.0181 6.88868 78.3728 6.76268 78.6248 6.51068C78.8488 6.29601 78.9608 6.00668 78.9608 5.64268C78.9608 5.21334 78.8161 4.88201 78.5268 4.64868C78.2841 4.45268 77.9621 4.35468 77.5608 4.35468H75.1668V6.88868Z"
    fill="var(--color-bloom-teal-700)"
  />
<path
    d="M87.0719 12.9507H84.1319V2.59068H87.0719C88.8639 2.59068 90.2686 3.10868 91.2859 4.14468C92.1913 5.06868 92.6439 6.27734 92.6439 7.77068C92.6439 9.47868 92.0606 10.804 90.8939 11.7467C89.9046 12.5493 88.6306 12.9507 87.0719 12.9507ZM85.9659 11.1867H87.0299C88.2339 11.1867 89.1673 10.8927 89.8299 10.3047C90.4833 9.71668 90.8099 8.87201 90.8099 7.77068C90.8099 6.52001 90.3899 5.60068 89.5499 5.01268C88.9059 4.57401 88.0659 4.35468 87.0299 4.35468H85.9659V11.1867Z"
    fill="var(--color-bloom-teal-700)"
  />
<path
    d="M94.8807 11.2987L96.0287 10.1087C96.4207 10.5567 96.7754 10.8787 97.0928 11.0747C97.5034 11.3267 97.9514 11.4527 98.4367 11.4527C99.0154 11.4527 99.4541 11.2847 99.7527 10.9487C99.9674 10.706 100.075 10.4167 100.075 10.0807C100.075 9.72601 99.9441 9.44134 99.6827 9.22668C99.4307 9.00268 98.9314 8.73668 98.1847 8.42868C97.2234 8.04601 96.5607 7.68201 96.1967 7.33668C95.6647 6.84201 95.3988 6.19334 95.3988 5.39068C95.3988 4.40134 95.7581 3.63601 96.4767 3.09468C97.0741 2.63734 97.8301 2.40868 98.7448 2.40868C99.7061 2.40868 100.635 2.73534 101.531 3.38868L100.579 4.81668C100.028 4.33134 99.3887 4.08868 98.6608 4.08868C98.1754 4.08868 97.8067 4.20068 97.5547 4.42468C97.3307 4.62068 97.2188 4.88201 97.2188 5.20868C97.2188 5.62868 97.4287 5.97868 97.8487 6.25868C98.0727 6.39868 98.4834 6.58534 99.0807 6.81868C100.051 7.19201 100.723 7.55601 101.097 7.91068C101.638 8.43334 101.909 9.12868 101.909 9.99668C101.909 11.014 101.573 11.8027 100.901 12.3627C100.294 12.876 99.4681 13.1327 98.4227 13.1327C96.9574 13.1327 95.7767 12.5213 94.8807 11.2987Z"
    fill="var(--color-bloom-teal-700)"
  />
</svg>
